var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditModify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8017 4.84296L12.4132 6.23139L9.76859 3.58677L11.157 2.19835C11.2893 2.06612 11.4545 2 11.6529 2C11.8512 2 12.0165 2.06612 12.1488 2.19835L13.8017 3.85123C13.9339 3.98346 14 4.14875 14 4.3471C14 4.54544 13.9339 4.71073 13.8017 4.84296ZM11.719 6.9256L4.64463 14H2V11.3553L9.07438 4.28098L11.719 6.9256Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditModify);
export default __webpack_public_path__ + "static/media/icon_edit_modify.1624cb48fd606f35f282e97a631b20df.svg";
export { ForwardRef as ReactComponent };